import React from 'react';
import PropTypes from 'prop-types';
import IconText from '@mapbox/mr-ui/icon-text';
import LevelIndicator from '../level-indicator/level-indicator';

class Card extends React.PureComponent {
  render() {
    const {
      thumbnail,
      level,
      language,
      description,
      path,
      title
    } = this.props;
    const renderedThumbnail = thumbnail && /*#__PURE__*/React.createElement("div", {
      className: "relative h120 mb6"
    }, thumbnail);
    const renderedLevel = level && /*#__PURE__*/React.createElement("div", {
      className: "mr12"
    }, /*#__PURE__*/React.createElement(LevelIndicator, {
      level: level
    }));
    const renderedLanguage = language && /*#__PURE__*/React.createElement(IconText, {
      iconBefore: "code"
    }, language);
    return /*#__PURE__*/React.createElement("a", {
      className: "dr-ui--card color-gray-dark transition color-blue-on-hover round clip inline-block w-full unprose pb18",
      href: path
    }, renderedThumbnail, /*#__PURE__*/React.createElement("div", null, (renderedLevel || renderedLanguage) && /*#__PURE__*/React.createElement("div", {
      className: "flex mb6 txt-bold color-gray txt-s"
    }, renderedLevel, renderedLanguage), /*#__PURE__*/React.createElement("div", {
      className: "mb6"
    }, title), description && /*#__PURE__*/React.createElement("div", {
      className: "color-gray color-gray-on-hover"
    }, description)));
  }

}

export default Card;